import React, { useContext } from 'react';
import { Typography, Divider, Card, Space } from 'antd';
import { ApplicationUIContext, ButtonGroup } from '@yuhuinc/ui-library';
import { StyledHeader } from '../common/Styles';
import { getTranslatedString } from 'helpers/i18n';
import ReAssignLease from './overview/ReAssignLease';
import Stats from './overview/Stats';
import Summary from './overview/Summary';
import Documents from './overview/Documents';

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.leaseOverview.${key}`);

const { Title } = Typography;

const Overview = () => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <Card>
      <StyledHeader>
        <Title level={isMobile ? 3 : 4}>{translate('overview.cardTitle')}</Title>
        <ButtonGroup buttons={[]} />
      </StyledHeader>

      <Divider />

      <Space direction="vertical" size="middle">
        <Stats />
        <ReAssignLease />
      </Space>

      <Divider />

      <Summary />

      <Divider />

      <Documents />
    </Card>
  );
};

export default Overview;
